<template>
  <Teleport to="body">
    <transition name="cp-fade">
      <div v-if="open" class="cp-backdrop" @mousedown.self="$emit('close')">
        <div class="cp-modal" role="dialog" aria-modal="true">

          <div class="cp-header">
            <span class="cp-title">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              Criar
            </span>
            <button class="cp-close" type="button" @click="$emit('close')" aria-label="Fechar">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
            </button>
          </div>

          <div class="cp-body">
            <template v-for="section in computedSections" :key="section.id">

              <!-- Mode divider (admin only) -->
              <div v-if="section.modeLabel" class="cp-mode-divider">
                <span class="cp-mode-icon" v-html="section.modeIcon" />
                {{ section.modeLabel }}
              </div>

              <!-- Group -->
              <div class="cp-group">
                <div class="cp-group-label">{{ section.label }}</div>
                <div class="cp-group-items">
                  <button
                    v-for="item in section.items"
                    :key="item.action + (item.payload || '')"
                    class="cp-item"
                    :class="[`cp-item--${item.color || 'default'}`]"
                    type="button"
                    @click="doAction(item.action, item.payload)"
                  >
                    <span class="cp-item-icon" v-html="item.icon" />
                    <span class="cp-item-label">{{ item.label }}</span>
                  </button>
                </div>
              </div>
            </template>
          </div>

        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

const ICON_REPORT_DAILY = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>`
const ICON_REPORT_INCIDENT = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.5 2L13 12H2L7.5 2Z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M7.5 6v3M7.5 10.5v.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`
const ICON_REPORT_GENERAL = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/><circle cx="7.5" cy="7" r="2" stroke="currentColor" stroke-width="1.2"/><path d="M5 11c0-1.38 1.12-2.5 2.5-2.5S10 9.62 10 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>`
const ICON_ACTIVITY = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="1.5" y="1.5" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.3"/><path d="M4.5 7.5l2 2 3.5-3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>`
const ICON_PENDENCIA = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.3"/><path d="M7.5 4v4l2.5 1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`
const ICON_REQUEST = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M3 5h9M3 5a2 2 0 110-4h9a2 2 0 110 4M3 5v8a2 2 0 002 2h5a2 2 0 002-2V5M6 9h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`
const ICON_NF = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="4.5" cy="5" r=".5" fill="currentColor"/></svg>`
const ICON_FORNECEDOR = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="7.5" cy="5" r="2.5" stroke="currentColor" stroke-width="1.3"/><path d="M2 13c0-3.04 2.46-5.5 5.5-5.5S13 9.96 13 13" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`
const ICON_RC = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="2" y="2" width="11" height="11" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M5 7.5h5M7.5 5v5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>`
const ICON_OC = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="2" y="2" width="11" height="11" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M4.5 7.5l2 2 3.5-3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>`
const ICON_QUIZ = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M4.5 5l1 1 2-2M4.5 9.5l1 1 2-2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 5.5h1M9.5 10h1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>`
const ICON_CC = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.3"/><path d="M7.5 4.5v1M7.5 9.5v1M5.5 6a2 2 0 014 0c0 1-1 1.5-2 2s-2 1-2 2a2 2 0 004 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>`

const MODEICON_CONST = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>`
const MODEICON_MAINT = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>`
const MODEICON_WARE = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/></svg>`
const MODEICON_OFFICE = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>`

interface CreateItem {
  label: string
  icon: string
  action: string
  payload?: string
  color?: string
}

interface CreateSection {
  id: string
  label: string
  items: CreateItem[]
  modeLabel?: string
  modeIcon?: string
}

export default defineComponent({
  name: 'CreatePopupModal',
  props: {
    open: { type: Boolean, default: false },
    currentMode: { type: String, default: 'construcao' },
    isAdmin: { type: Boolean, default: false },
    canManageConstruction: { type: Boolean, default: true },
    canManageMaintenance: { type: Boolean, default: false },
    canManageWarehouse: { type: Boolean, default: false },
    canManageOffice: { type: Boolean, default: false }
  },
  emits: ['close', 'action'],
  setup(props, { emit }) {

    const construcaoSections = (): CreateSection[] => [
      {
        id: 'c-relatorios',
        label: 'Relatórios',
        items: [
          { label: 'Relatório diário de obra', icon: ICON_REPORT_DAILY, action: 'start-report', payload: 'Relatorio diario de obra', color: 'blue' },
          { label: 'Relatório de incidente', icon: ICON_REPORT_INCIDENT, action: 'start-report', payload: 'Relatorio de incidente', color: 'orange' },
          { label: 'Relatório geral', icon: ICON_REPORT_GENERAL, action: 'start-report', payload: 'Relatorio geral', color: 'teal' }
        ]
      },
      {
        id: 'c-planejamento',
        label: 'Planejamento',
        items: [
          { label: 'Criar atividade', icon: ICON_ACTIVITY, action: 'start-atividade', color: 'blue' }
        ]
      },
      {
        id: 'c-acompanhamento',
        label: 'Acompanhamento',
        items: [
          { label: 'Registrar pendência', icon: ICON_PENDENCIA, action: 'start-pendencia', color: 'orange' }
        ]
      }
    ]

    const manutencaoSections = (): CreateSection[] => [
      {
        id: 'm-os',
        label: 'Ordens de Serviço',
        items: [
          { label: 'Criar OS', icon: ICON_RC, action: 'maintenance-create-os', color: 'blue' },
          { label: 'Criar atividade para OS existente', icon: ICON_ACTIVITY, action: 'maintenance-add-os-item', color: 'blue' },
          { label: 'Designar OS', icon: ICON_REQUEST, action: 'maintenance-designate-os', color: 'blue' }
        ]
      },
      {
        id: 'm-seguranca',
        label: 'Segurança',
        items: [
          { label: 'Registrar incidente', icon: ICON_REPORT_INCIDENT, action: 'start-manut-incidente', color: 'orange' }
        ]
      }
    ]

    const almoxarifadoSections = (): CreateSection[] => [
      {
        id: 'a-operacoes',
        label: 'Operações',
        items: [
          { label: 'Solicitar item', icon: ICON_REQUEST, action: 'warehouse-request-item', color: 'green' },
          { label: 'Importar nota fiscal', icon: ICON_NF, action: 'warehouse-nfe-import', color: 'green' }
        ]
      }
    ]

    const escritorioSections = (): CreateSection[] => [
      {
        id: 'e-cadastros',
        label: 'Cadastros',
        items: [
          { label: 'Novo fornecedor', icon: ICON_FORNECEDOR, action: 'office-tab', payload: 'fornecedores', color: 'peach' }
        ]
      },
      {
        id: 'e-compras',
        label: 'Compras',
        items: [
          { label: 'Nova req. de compra', icon: ICON_RC, action: 'office-tab', payload: 'rc', color: 'peach' },
          { label: 'Nova ordem de compra', icon: ICON_OC, action: 'office-tab', payload: 'oc', color: 'peach' }
        ]
      },
      {
        id: 'e-financeiro',
        label: 'Financeiro',
        items: [
          { label: 'Nova nota fiscal', icon: ICON_NF, action: 'office-tab', payload: 'nf', color: 'peach' },
          { label: 'Novo centro de custo', icon: ICON_CC, action: 'office-tab', payload: 'cc', color: 'peach' }
        ]
      },
      {
        id: 'e-treinamento',
        label: 'Treinamento',
        items: [
          { label: 'Novo questionário', icon: ICON_QUIZ, action: 'office-tab', payload: 'questionarios', color: 'peach' }
        ]
      }
    ]

    const computedSections = computed((): CreateSection[] => {
      const mode = props.currentMode

      if (mode === 'construcao') return construcaoSections()
      if (mode === 'manutencao') return manutencaoSections()
      if (mode === 'almoxarifado') return almoxarifadoSections()
      if (mode === 'escritorio') return escritorioSections()

      // admin: all available modes
      const all: CreateSection[] = []

      if (props.canManageConstruction) {
        const sections = construcaoSections()
        sections[0] = { ...sections[0], modeLabel: 'Construção', modeIcon: MODEICON_CONST }
        all.push(...sections)
      }
      if (props.canManageMaintenance) {
        const sections = manutencaoSections()
        sections[0] = { ...sections[0], modeLabel: 'Manutenção', modeIcon: MODEICON_MAINT }
        all.push(...sections)
      }
      if (props.canManageWarehouse) {
        const sections = almoxarifadoSections()
        sections[0] = { ...sections[0], modeLabel: 'Almoxarifado', modeIcon: MODEICON_WARE }
        all.push(...sections)
      }
      if (props.canManageOffice) {
        const sections = escritorioSections()
        sections[0] = { ...sections[0], modeLabel: 'Escritório', modeIcon: MODEICON_OFFICE }
        all.push(...sections)
      }

      return all
    })

    const doAction = (action: string, payload?: string) => {
      emit('action', action, payload)
      emit('close')
    }

    return { computedSections, doAction }
  }
})
</script>

<style scoped lang="scss">
/* ── Backdrop ────────────────────────────── */
.cp-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

/* ── Modal card ──────────────────────────── */
.cp-modal {
  background: var(--card, #fff);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.22), 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border, rgba(0, 0, 0, 0.08));
  width: min(480px, 100%);
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Header ──────────────────────────────── */
.cp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid var(--border, rgba(0, 0, 0, 0.07));
  flex-shrink: 0;
}

.cp-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: var(--ink, #1a1a18);

  svg { color: var(--accent, #0078d4); }
}

.cp-close {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--ink-muted, #888);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: var(--surface-3, rgba(0, 0, 0, 0.06));
    color: var(--ink, #1a1a18);
  }
}

/* ── Body ────────────────────────────────── */
.cp-body {
  overflow-y: auto;
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
  scrollbar-width: thin;
}

/* ── Mode divider ────────────────────────── */
.cp-mode-divider {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ink-muted, #999);
  padding: 14px 0 6px;
  margin-top: 2px;

  &:first-child { padding-top: 0; }

  :deep(svg) { opacity: 0.7; flex-shrink: 0; }
}

/* ── Group ───────────────────────────────── */
.cp-group {
  margin-bottom: 14px;

  &:last-child { margin-bottom: 0; }
}

.cp-group-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--ink-faint, #aaa);
  margin-bottom: 6px;
  padding: 0 2px;
}

/* ── Items grid ──────────────────────────── */
.cp-group-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
}

/* ── Item button ─────────────────────────── */
.cp-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1.5px solid var(--border, rgba(0, 0, 0, 0.09));
  background: var(--surface-2, #f8f7f6);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.13s, background 0.13s, box-shadow 0.13s;
  font-size: 13px;
  font-weight: 500;
  color: var(--ink, #1a1a18);
  line-height: 1.3;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  /* Color variants */
  &--blue {
    .cp-item-icon { background: rgba(0, 120, 212, 0.1); color: #0078d4; }
    &:hover { border-color: rgba(0, 120, 212, 0.35); background: rgba(0, 120, 212, 0.04); }
  }
  &--orange {
    .cp-item-icon { background: rgba(216, 59, 1, 0.1); color: #d83b01; }
    &:hover { border-color: rgba(216, 59, 1, 0.35); background: rgba(216, 59, 1, 0.04); }
  }
  &--teal {
    .cp-item-icon { background: rgba(0, 141, 114, 0.1); color: #008d72; }
    &:hover { border-color: rgba(0, 141, 114, 0.35); background: rgba(0, 141, 114, 0.04); }
  }
  &--yellow {
    .cp-item-icon { background: rgba(251, 191, 36, 0.15); color: #b45309; }
    &:hover { border-color: rgba(251, 191, 36, 0.5); background: rgba(251, 191, 36, 0.06); }
  }
  &--green {
    .cp-item-icon { background: rgba(16, 124, 16, 0.1); color: #107c10; }
    &:hover { border-color: rgba(16, 124, 16, 0.35); background: rgba(16, 124, 16, 0.04); }
  }
  &--peach {
    .cp-item-icon { background: rgba(251, 146, 60, 0.12); color: #c2410c; }
    &:hover { border-color: rgba(251, 146, 60, 0.45); background: rgba(251, 146, 60, 0.05); }
  }
  &--default {
    .cp-item-icon { background: var(--surface-3, rgba(0,0,0,.07)); color: var(--ink-muted, #888); }
    &:hover { border-color: var(--border-strong, rgba(0, 0, 0, 0.2)); }
  }
}

.cp-item-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.13s;

  :deep(svg) { display: block; }
}

.cp-item-label {
  flex: 1;
  min-width: 0;
}

/* ── Transition ──────────────────────────── */
.cp-fade-enter-active,
.cp-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.cp-fade-enter-from,
.cp-fade-leave-to {
  opacity: 0;
  transform: scale(0.96) translateY(6px);
}

@media (max-width: 520px) {
  .cp-group-items {
    grid-template-columns: 1fr;
  }
  .cp-modal {
    border-radius: 14px 14px 0 0;
    align-self: flex-end;
    width: 100%;
    max-height: 85vh;
  }
  .cp-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .cp-fade-enter-from,
  .cp-fade-leave-to {
    transform: translateY(20px);
  }
}
</style>
